import { Component, OnInit, Renderer, ViewChild, ElementRef, Directive } from '@angular/core';
import { ROUTES } from '../.././sidebar/sidebar.component';
import { Router, ActivatedRoute, NavigationEnd, NavigationStart } from '@angular/router';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { Subscription } from 'rxjs/Subscription';
import { environment } from '../../../environments/environment';
import { GetPracticeMessagesService } from '../../services/practicemessages.service';
import { PracticeMessages } from '../../model/models';
import { CommonService, PatientPortalDemographicsService, ConfirmDialogService, DataSharingService, GetPatientPortalTeleHealthDataService } from '../../services/api';
import { ToastrService } from 'ngx-toastr';
import PerfectScrollbar from 'perfect-scrollbar';
var misc: any = {
    navbar_menu_visible: 0,
    active_collapse: true,
    disabled_collapse_init: 0,
}

@Component({
    moduleId: module.id,
    selector: 'navbar-cmp',
    templateUrl: 'navbar.component.html'
})

export class NavbarComponent implements OnInit {
    private listTitles: any[];
    location: Location;
    private nativeElement: Node;
    private toggleButton;
    private sidebarVisible: boolean;
    private _router: Subscription;
    public open: boolean = false;
    public AlertData: PracticeMessages[] = [];
    public practiceName: string;
    public isTelemed: boolean = false;
    public isInstaPract: boolean = false;
    loggedin: string = '';
    oitReq: boolean= false;
    @ViewChild("navbar-cmp", { static: false }) button;
    public isAlerts: boolean = false;
    constructor(location: Location, private renderer: Renderer, private element: ElementRef, private router: Router, private alertService: GetPracticeMessagesService, private tokenService: CommonService, private demService: PatientPortalDemographicsService, private toastr: ToastrService, private confirmBox: ConfirmDialogService, private teleHealthService: GetPatientPortalTeleHealthDataService) {
        this.location = location;
        this.nativeElement = element.nativeElement;
        this.sidebarVisible = false;
        //if (environment.appSetting.requestFrom == "oitconnect")
        //    this.oitReq = true;
        //else
        //    this.oitReq = false;
    }

    ngOnInit() {
        //const elemNavbar = <HTMLElement>document.querySelector('.dropdown-menu-center');
        //let ps = new PerfectScrollbar(elemNavbar);
        //const html = document.getElementsByTagName('html')[0];
        //html.classList.add('perfect-scrollbar-on');
        this.listTitles = ROUTES.filter(listTitle => listTitle);
        const navbar: HTMLElement = this.element.nativeElement;
        const body = document.getElementsByTagName('body')[0];
        this.toggleButton = navbar.getElementsByClassName('navbar-toggler')[0];
        if (body.classList.contains('sidebar-mini')) {
            misc.sidebar_mini_active = true;
        }
        this._router = this.router.events.filter(event => event instanceof NavigationEnd).subscribe((event: NavigationEnd) => {
            const $layer = document.getElementsByClassName('close-layer')[0];
            if ($layer) {
                $layer.remove();
            }
        });
        let userCred = localStorage.getItem('userVal');
        var CryptoJS = require("crypto-js");
        var SECRET_KEY = 'm@duLeMD#2k19';
        let decrVal = CryptoJS.AES.decrypt(userCred, SECRET_KEY);
        decrVal = decrVal.toString(CryptoJS.enc.Utf8);
        let userData = JSON.parse(localStorage.getItem('usersession'));
        this.loggedin = userData[0].LastLoginTime;
        this.tokenService.GetPortalKey(decrVal.split(',')[0], decrVal.split(',')[1]);
        let headerContext: { [key: string]: string } = {};
        headerContext["Context"] = "{'userid': '" + userData[0].UserId + "','practiceid': '" + environment.UserPracticeId + "'}";
        this.alertService.configuration.apiKeys = headerContext;
        this.alertService.configuration.accessToken = environment.portalAccessKey;
        this.alertService.GetPracticeLoginMessages().map(t => t).subscribe(items => {

            this.AlertData = items;
            if (this.AlertData.length > 0) {
                this.isAlerts = true;
                this.toastr.info('You have ' + this.AlertData.length + ' Notifications', '', { timeOut: 3000, positionClass: 'toast-top-center' });
            }
        });
        this.demService.configuration.apiKeys = headerContext;
        this.demService.configuration.accessToken = environment.portalAccessKey;
        this.demService.patientPortalDemographics(userData[0].PatientId).subscribe(items => {
            if (items.PatientInfo.TelemedPatientId != '')
                this.isTelemed = true;
            else
                this.isTelemed = false;
            if (items.PatientInfo.InstaPractPatientId != '' && environment.appSetting.teleHealthAccess == 'InstaPract')
                this.isInstaPract = true;
            else
                this.isInstaPract = false;

            localStorage.setItem('patientinfo', JSON.stringify(items));
            this.practiceName = items.PatientInfo.PracticeName;
            localStorage.setItem('practicename', this.practiceName);
        });


    }

    minimizeSidebar() {
        const body = document.getElementsByTagName('body')[0];

        if (misc.sidebar_mini_active === true) {
            body.classList.remove('sidebar-mini');
            misc.sidebar_mini_active = false;

        } else {
            setTimeout(function () {
                body.classList.add('sidebar-mini');

                misc.sidebar_mini_active = true;
            }, 300);
        }

        // we simulate the window Resize so the charts will get updated in realtime.
        const simulateWindowResize = setInterval(function () {
            window.dispatchEvent(new Event('resize'));
        }, 180);

        // we stop the simulation of Window Resize after the animations are completed
        setTimeout(function () {
            clearInterval(simulateWindowResize);
        }, 1000);
    }

    isMobileMenu() {
        if (window.outerWidth < 991) {
            return false;
        }
        return true;
    }

    sidebarOpen() {
        var toggleButton = this.toggleButton;
        var html = document.getElementsByTagName('html')[0];
        setTimeout(function () {
            toggleButton.classList.add('toggled');
        }, 500);
        const mainPanel = <HTMLElement>document.getElementsByClassName('main-panel')[0];
        if (window.innerWidth < 991) {
            mainPanel.style.position = 'fixed';
        }
        html.classList.add('nav-open');
        this.sidebarVisible = true;
    }
    sidebarClose() {
        var html = document.getElementsByTagName('html')[0];
        this.toggleButton.classList.remove('toggled');
        this.sidebarVisible = false;
        html.classList.remove('nav-open');
        const mainPanel = <HTMLElement>document.getElementsByClassName('main-panel')[0];

        if (window.innerWidth < 991) {
            setTimeout(function () {
                mainPanel.style.position = '';
            }, 500);
        }
    }
    sidebarToggle() {
        // var toggleButton = this.toggleButton;
        // var body = document.getElementsByTagName('body')[0];
        if (this.sidebarVisible == false) {
            this.sidebarOpen();
        } else {
            this.sidebarClose();
        }
    }

    getTitle() {
        var titlee = this.location.prepareExternalUrl(this.location.path());
        if (titlee.charAt(0) === '#') {
            titlee = titlee.slice(1);
        }
        for (var item = 0; item < this.listTitles.length; item++) {
            var parent = this.listTitles[item];
            if (parent.path === titlee) {
                return parent.title;
            } else if (parent.children) {
                var children_from_url = titlee.split("/")[2];
                for (var current = 0; current < parent.children.length; current++) {
                    if (parent.children[current].path === children_from_url) {
                        return parent.children[current].title;
                    }
                }
            }
        }
        return 'Dashboard';
    }

    getPath() {
        return this.location.prepareExternalUrl(this.location.path());
    }
    goToLogin(): any {
        this.router.navigate(['login']);
    }
    logout() {
        //if (confirm("Are you sure you want to Log Off?")) {
        //    this.router.navigate(['login']);
        //}
        this.confirmBox.confirmThis("logout", () => {
            localStorage.clear();
            localStorage.removeItem("newlogin");
            localStorage.removeItem("usersession");
            localStorage.removeItem("userVal");
            if (environment.usertype == 'b2cuser') {                
               window.location.href = environment.appSetting.connectmmdURL;
            }
            else if (environment.appSetting.logoutURL!= "")
            {
                window.location.href = environment.appSetting.logoutURL;
                return;
            }
            else
            this.router.navigate(['login']);
        }, function () {
            return false;
        })
    }

    closeApp() {
        //localStorage.clear();
        //localStorage.removeItem("newlogin");
        //localStorage.removeItem("usersession");
        //localStorage.removeItem("userVal");
        var win = window.open("about:blank", "_self");
        win.close();

    }
    teleHealth(type) {
        let userCred = localStorage.getItem('userVal');
        var CryptoJS = require("crypto-js");
        var SECRET_KEY = 'm@duLeMD#2k19';
        let decrVal = CryptoJS.AES.decrypt(userCred, SECRET_KEY);
        decrVal = decrVal.toString(CryptoJS.enc.Utf8);
        let userData = JSON.parse(localStorage.getItem('usersession'));
        this.tokenService.GetPortalKey(decrVal.split(',')[0], decrVal.split(',')[1]);
        let headerContext: { [key: string]: string } = {};
        headerContext["Context"] = "{'userid': '" + userData[0].UserId + "','practiceid': '" + environment.UserPracticeId + "'}";
        this.teleHealthService.configuration.apiKeys = headerContext;
        this.teleHealthService.configuration.accessToken = environment.portalAccessKey;
        if (type == 'snapMD')
        {
            this.teleHealthService.getPatientPortalTeleHealthData(userData[0].PatientId).subscribe(resultData => {
                var winWidth = window.screen.availWidth - 50;
                var winHeight = window.screen.availHeight - 50;
                //let resultData = JSON.parse(data);
                if (resultData.Success == true) {
                    window.open(resultData.Url, '_blank', 'width=' + winWidth + ',height=' + winHeight + ',top=0,location=no,left=0,resizable=1,scrollbars=1');
                }
                else {
                    this.toastr.error(resultData.Message);
                }
            });
        }
        else {
            this.teleHealthService.getInstaPracticeAccessToken(userData[0].PatientId, 'patient').subscribe(resultData => {    
               // let resultData = JSON.parse(data);
                var winWidth = window.screen.availWidth - 50;
                var winHeight = window.screen.availHeight - 50;
                if (resultData.Result == true) {
                    window.open(environment.appSetting.instaPractURL + '?token=' + resultData.Token, '_blank', 'width=' + winWidth + ',height=' + winHeight + ',top=0,location=no,left=0,resizable=1,scrollbars=1');
                }
                else {
                    this.toastr.error(resultData.Message);
                }
            });

        }
    }
    showAlerts() {
        //this.router.navigate(['notification']);
    }
}
